export default "__VITE_ASSET__9b78363b__"